import * as React from 'react';

/**
 * @description GooglePlayIcon icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { GooglePlayIcon } from '@sravni/design-system-icons'
 *
 * <GooglePlayIcon />
 * ```
 */
const GooglePlayIcon = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "GooglePlayIcon", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M2.345 1.097c-.24.283-.362.648-.342 1.018v16.087a1.41 1.41 0 0 0 .342 1.019l.05.058 9.012-9.011v-.218L2.396 1.046l-.051.051Z", fill: "url(#GooglePlayIcon__a)" }),
    React.createElement("path", { d: "m14.389 13.271-2.982-3.003v-.218l2.982-3.004.065.044 3.57 2.022c1.02.574 1.02 1.52 0 2.101l-3.555 2.022-.08.037Z", fill: "url(#GooglePlayIcon__b)" }),
    React.createElement("path", { d: "m14.476 13.228-3.07-3.07-9.061 9.063a1.178 1.178 0 0 0 1.505.05l10.626-6.043Z", fill: "url(#GooglePlayIcon__c)" }),
    React.createElement("path", { d: "M14.476 7.09 3.85 1.052a1.171 1.171 0 0 0-1.505.044l9.062 9.062 3.069-3.07Z", fill: "url(#GooglePlayIcon__d)" }),
    React.createElement("defs", null,
        React.createElement("linearGradient", { id: "GooglePlayIcon__a", x1: "10.607", y1: "1.948", x2: "-1.597", y2: "14.152", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#00A0FF" }),
            React.createElement("stop", { offset: ".01", stopColor: "#00A1FF" }),
            React.createElement("stop", { offset: ".26", stopColor: "#00BEFF" }),
            React.createElement("stop", { offset: ".51", stopColor: "#00D2FF" }),
            React.createElement("stop", { offset: ".76", stopColor: "#00DFFF" }),
            React.createElement("stop", { offset: "1", stopColor: "#00E3FF" })),
        React.createElement("linearGradient", { id: "GooglePlayIcon__b", x1: "19.356", y1: "10.159", x2: "1.763", y2: "10.159", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#FFE000" }),
            React.createElement("stop", { offset: ".41", stopColor: "#FFBD00" }),
            React.createElement("stop", { offset: ".78", stopColor: "orange" }),
            React.createElement("stop", { offset: "1", stopColor: "#FF9C00" })),
        React.createElement("linearGradient", { id: "GooglePlayIcon__c", x1: "12.81", y1: "11.832", x2: "-3.742", y2: "28.377", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#FF3A44" }),
            React.createElement("stop", { offset: "1", stopColor: "#C31162" })),
        React.createElement("linearGradient", { id: "GooglePlayIcon__d", x1: ".061", y1: "-4.256", x2: "7.45", y2: "3.133", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { stopColor: "#32A071" }),
            React.createElement("stop", { offset: ".07", stopColor: "#2DA771" }),
            React.createElement("stop", { offset: ".48", stopColor: "#15CF74" }),
            React.createElement("stop", { offset: ".8", stopColor: "#06E775" }),
            React.createElement("stop", { offset: "1", stopColor: "#00F076" }))))));

export { GooglePlayIcon };
//# sourceMappingURL=GooglePlayIcon.js.map
